import axios from 'axios'

const tsRespondersPath = 'ts-responders'
const tsProxiesPath = 'ts-proxies'
const docSignersPath = 'doc-signers'
const ocspRespondersPath = 'ocsp-responders'

export default {
  // tsResponder
  async createTsResponder(tsResponderDto) {
    await axios.post(`${tsRespondersPath}`, tsResponderDto)
  },

  async updateTsResponder(name, tsResponderUpdate) {
    const resp = await axios.put(`${tsRespondersPath}/${name}`, tsResponderUpdate)
    return resp.data
  },

  async getTsResponder(name) {
    const resp = await axios.get(`${tsRespondersPath}/${name}`)
    return resp.data
  },

  async listTsResponders(q, pageRequest) {
    const resp = await axios.get(`${tsRespondersPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async deleteTsResponder(name, deleteKey = true) {
    await axios.delete(`${tsRespondersPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  },

  // tsProxy
  async createTsProxy(tsProxyDto) {
    await axios.post(`${tsProxiesPath}`, tsProxyDto)
  },

  async updateTsProxy(name, tsProxyUpdate) {
    await axios.put(`${tsProxiesPath}/${name}`, tsProxyUpdate)
  },

  async getTsProxy(name) {
    const resp = await axios.get(`${tsProxiesPath}/${name}`)
    return resp.data
  },

  async listTsProxies(q, pageRequest) {
    const resp = await axios.get(`${tsProxiesPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async listAllResponderNames() {
    const resp = await axios.get(`${tsRespondersPath}/names`)
    return resp.data
  },

  async deleteTsProxy(name, deleteKey = true) {
    await axios.delete(`${tsProxiesPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  },

  // docSigner
  async createDocSigner(docSignerDto) {
    await axios.post(`${docSignersPath}`, docSignerDto)
  },

  async updateDocSigner(name, docSignerUpdate) {
    const resp = await axios.put(`${docSignersPath}/${name}`, docSignerUpdate)
    return resp.data
  },

  async getDocSigner(name) {
    const resp = await axios.get(`${docSignersPath}/${name}`)
    return resp.data
  },

  async listDocSigners(q, pageRequest) {
    const resp = await axios.get(`${docSignersPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async generateGPGCertificatedPublicKey(name, DN) {
    const resp = await axios.get(`${docSignersPath}/${name}/gengpgpublickey/${DN}`)
    return resp.data
  },

  async deleteDocSigner(name, deleteKey = true) {
    await axios.delete(`${docSignersPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  },

  // ocspResponder
  async createOcspResponder(ocspResponderDto) {
    await axios.post(`${ocspRespondersPath}`, ocspResponderDto)
  },

  async updateOcspResponder(name, ocspResponderUpdate) {
    const resp = await axios.put(`${ocspRespondersPath}/${name}`, ocspResponderUpdate)
    return resp.data
  },

  async getOcspResponder(name) {
    const resp = await axios.get(`${ocspRespondersPath}/${name}`)
    return resp.data
  },

  async listOcspResponders(q, pageRequest) {
    const resp = await axios.get(`${ocspRespondersPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async deleteOcspResponder(name, deleteKey = true) {
    await axios.delete(`${ocspRespondersPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  }
}
